import React,{useEffect,useRef} from "react";
import Doubleimg from "../assets/PhotosDouble.avif"
import Done from "../assets/Done.svg"
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const WhiteCard = ()=>{
    const card = useRef(null);


    useEffect(()=>{
        gsap.set(card.current,{opacity:0,y:100});
        gsap.to(card.current,{
            opacity:1,
            y:0,
            duration:1,
            scrollTrigger:{
                trigger:card.current,
                start:"top 80%",
                end:"bottom top",
                toggleActions:"play none none none",
            }
        })
    },[])

    return(
        <>
        {/* white square section */}
        <div ref={card} className="w-full h-content bg-whitecard-background bg-cover bg-no-repeat rounded-xl pt-10 md:pt-14 xl:pt-24 mb-10 font-guton max-w-[1440px] mx-auto">
        <h2 className="text-24 leading-18 text-center md:text-36 md:leading-30 xl:text-64 xl:leading-55 w-90 md:w-70 mx-auto font-medium tracking-[-2px] md:tracking-[-3px]">The Perks of Choosing <span className="text-red font-bold">Estudy</span> for Your Education Journey</h2>
        <p className="text-14 leading-12 text-black md:text-18 md:leading-18 xl:text-32 text-center xl:leading-30 w-70 md:w-1/2 mx-auto mt-1 mb-4 md:my-2 tracking-[-1px]">See why hundreds of students trust us to achieve their goals</p>
        <div className="w-95 flex-col md:flex-row flex md:space-x-4 xl:space-x-12 mx-auto">
            <div className="w-70 mx-auto md:w-90 xl:w-70">
                <img className="relative md:-top-10 xl:-top-16" src={Doubleimg} alt="" />
            </div>
            <div className="w-85 mx-auto flex flex-col md:tracking-[-0.6px] md:pb-8 pb-6 pt-6 md:pt-6 xl:py-12 items-start">
                <div className="flex space-x-4 mb-2 md:mb-4 xl:mb-8">
                    <div className="w-6 h-6 xl:w-10 xl:h-10 bg-red rounded-full"><img src={Done} alt="" /></div>
                    <p className="text-12 leading-12 w-85 md:text-14 xl:text-21 w-70 md:leading-12 xl:leading-21"><span className="font-semibold">Financial Relief:</span> Our cost-effective solutions and guidance help students save time & money</p>
                </div>
                <div className="flex space-x-4 mb-2  md:mb-4 xl:mb-8">
                    <div className="w-6 h-6 xl:w-10 xl:h-10 bg-red rounded-full"><img src={Done} alt="" /></div>
                    <p className="text-12 leading-12 w-85 md:text-14 xl:text-21 w-70 md:leading-12 xl:leading-21"><span className="font-semibold">Stress-Free:</span> With our service, you can say goodbye to the confusion & overwhelming burden of paperwork, decisions, and practical challenges.</p>
                </div>
                <div className="flex space-x-4 mb-2 md:mb-4 xl:mb-8">
                    <div className="w-6 h-6 xl:w-10 xl:h-10 bg-red rounded-full"><img src={Done} alt="" /></div>
                    <p className="text-12 leading-12 w-85 md:text-14 xl:text-21 w-70 md:leading-12 xl:leading-21"><span className="font-semibold">Shaping your future:</span> Beyond education, we support students in building their careers by helping them find job opportunities abroad.</p>
                </div>
                <div className="flex space-x-4 mb-2 md:mb-4 xl:mb-8">
                    <div className="w-6 h-6 xl:w-10 xl:h-10 bg-red rounded-full"><img src={Done} alt="" /></div>
                    <p className="text-12 leading-12 w-85 md:text-14 xl:text-21 w-70 md:leading-12 xl:leading-21"><span className="font-semibold">Custom Services:</span> Each Student gets customized guidance, making sure their specific needs are met.</p>
                </div>
                <div className="flex space-x-4">
                    <div className="w-6 h-6 xl:w-10 xl:h-10 bg-red rounded-full"><img src={Done} alt="" /></div>
                    <p className="text-12 leading-12 w-85 md:text-14 xl:text-21 w-70 md:leading-12 xl:leading-21"><span className="font-semibold">Eﬃcient System:</span> From university placements to visa application and accommodation. This creates a smooth transition, saving time, effort, and stress.</p>
                </div>
                 
            </div>

        </div>
    </div>
    </>
    )
}

export default WhiteCard;